import * as React from 'react'
import * as styles from './BootErrorScreen.module.css'

interface Props {
	message: string
	onRefresh?: () => void
}

export function BootErrorScreen({ message, onRefresh = () => window.location.reload() }: Props): JSX.Element {
	return (
		<div className={styles.container} data-testid="boot-error-screen">
			<p className={styles.message}>{message}</p>
			<button className="skin__secondary-button" onClick={onRefresh}>
				{i18n.t('boot-error.refresh')}
			</button>
		</div>
	)
}
